module.exports = __webpack_public_path__ + "assets/arr.0f1a1bbb.svg";